import { mapValues } from '../../../utils/map-values';
import { getTypeOfValue, ValueType } from './get-type-of-value';
import { isSerializedValue, SerializedValueType } from './serialized-value';
const deserializeDate = (value) => {
    return new Date(value);
};
const deserializeSet = (valueArray) => {
    return new Set(deserializeArray(valueArray));
};
const deserializeMap = (valueArray) => {
    return new Map(deserializeArray(valueArray));
};
const deserializeSerializedValue = (object) => {
    switch (object._type_) {
        case SerializedValueType.Date:
            return deserializeDate(object._value_);
        case SerializedValueType.Set:
            return deserializeSet(object._value_);
        case SerializedValueType.Map:
            return deserializeMap(object._value_);
        default:
            throw new Error(`SerializedValue.type '${object._type_}' unknown. Failed to parse value.`);
    }
};
const deserializeObject = (object) => {
    if (isSerializedValue(object))
        return deserializeSerializedValue(object);
    return mapValues(object, deserializeValue);
};
const deserializeArray = (array) => {
    return array.map(element => deserializeValue(element));
};
export const deserializeValue = (value) => {
    const type = getTypeOfValue(value);
    switch (type) {
        case ValueType.Object:
            return deserializeObject(value);
        case ValueType.Array:
            return deserializeArray(value);
        default:
            return value;
    }
};
